import { boxShadow } from "assets/jss/material-kit-pro-react";
import { main } from "assets/jss/material-kit-pro-react.js";

const sectionsPageStyle = {
	main: {
		...main,
		background: "#F7FBFF",
	},
	paddingTop: {
		paddingTop: "100px",
	},
	marginTop: {
		marginTop: "90px",
	},
	mainBackground: {
		backgroundColor: "#F7FBFF",
	},
	leftSide: {
		padding: "20px 0",
		height: "100vh",
		overflowY: "auto",
		backgroundColor: "#F7FBFF",
		boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
		borderRadius: "0.625rem",
		width: "5%",
		minWidth: "100px",
		marginLeft: "5px",
	},
	rightSide: {
		padding: "0px 0",
		minHeight: "100vh",
		width: "90%",
	},
	landingTitle: {
		color: "#072A40",
		fontSize: "32px",
		textAlign: "center",
		fontWeight: "500",
		marginTop: "5px",
	},
	landingTitle2: {
		color: "#072A40",
		fontSize: "32px",
		textAlign: "left",
		fontWeight: "500",
		marginTop: "5px",
	},
	container: {
		padding: "0px 0",
		width: "100%",
		"@media (min-width: 1200px)": {
			maxWidth: "1200px",
		},
	},
	chooseSection: {
		backgroundColor: "#fff",
		display: "flex",
		justifyContent: "center",
		width: "100%",
		marginLeft: "auto",
		marginRight: "auto",
		paddingLeft: "15px",
		paddingRight: "15px",
		paddingTop: "20px",
		paddingBottom: "20px",
		boxShadow: "0 1px 0px 0 rgba(0, 0, 0, 0.1)",
	},
	chooseProductPortfolio: {
		display: "flex",
		justifyContent: "center",
		width: "100%",
		marginLeft: "auto",
		marginRight: "auto",
		paddingLeft: "15px",
		paddingRight: "15px",
		paddingTop: "20px",
		paddingBottom: "20px",
		// boxShadow: "0 1px 0px 0 rgba(0, 0, 0, 0.1)",
	},
	landingDescription: {
		color: "#072A40",
		fontSize: "14px",
		textAlign: "justify",
		fontWeight: "400",
		marginTop: "5px",
		marginBottom: "5px",
		fontFamily: "Rubik-regular",
	},
	joinUs: {
		color: "#FDFDFDFF",
		fontSize: "22px",
		backgroundColor: "#007DFF",
		borderRadius: "1.825rem",
		marginTop: "25px",
		padding: "10px",
		textAlign: "left",
		fontWeight: "400",
		marginTop: "5px",
		paddingLeft: "20px",
		paddingRight: "20px",
		marginBottom: "5px",
		fontFamily: "Rubik-Medium",
		transition: "0.4s",
		duration: "0.4s",
		boxShadow:
			"rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
		"& span": {
			color: "#FDFDFDFF",
			fontSize: "20px",
			textAlign: "left",
			paddingLeft: "10px",
			fontWeight: "400",
			marginRight: "5px",
			fontFamily: "Rubik-Medium",
		},
		"& span:hover": {
			color: "#F4F8FBFF !important",
			cursor: "pointer",
		},
		"&:hover": {
			color: "#F4F8FBFF !important",
			backgroundColor: "#072A40",
			cursor: "pointer",
			boxShadow:
				"rgba(14, 63, 126, 0.04) 0px 2px 2px 1px, rgba(42, 51, 69, 0.04) 0px 1px 10px -0.5px, rgba(42, 51, 70, 0.04) 0px 10px 10px -1.5px, rgba(42, 51, 70, 0.04) 0px 10px 10px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
			transition: "0.4s",
			duration: "0.4s",
		},
	},
	portFolioImage: {
		// image should be horizontal centered
		display: "flex",
		justifyContent: "center",
		itemsAlign: "center",
		alignItems: "center",
		width: "100%",
		marginLeft: "auto",
		marginRight: "auto",
		// paddingLeft: "15px",
		// paddingRight: "15px",
		// paddingTop: "20px",
	},
	keyTitle: {
		color: "#072A40",
		fontSize: "18px",
		textAlign: "left",
		fontWeight: "500",
		marginTop: "5px",
		marginBottom: "5px",
		fontFamily: "Rubik-Medium",
		"& span": {
			fontSize: "18px",
			textAlign: "left",
			fontWeight: "400",
			marginRight: "5px",
			fontFamily: "Rubik-regular",
		},
	},

	keyPointSection: {
		// borderRadius: "10px",
		borderRadius: "0.625rem",
		boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
		padding: "10px",
		margin: "15px",
		transition: "0.4s",
		duration: "0.4s",
		"&:hover": {
			boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.2)",
			transition: "0.4s",
			duration: "0.4s",
		},
		borderLeft: "4px solid #1E88CAFF",
	},
	landingImage: {
		width: "100%",
		height: "auto",
		padding: "0px",
		transition: "0.2s",
		duration: "0.2s",
		backgroundColor: "white",
		borderRadius: "0.625rem",
		boxShadow:
			"rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
		"&:hover": {
			// boxShadow: "0 1px 2px 0 #072A40",
			boxShadow:
				"rgba(14, 63, 126, 0.04) 0px 10px 2px 1px, rgba(42, 51, 69, 0.04) 0px 1px 10px -0.5px, rgba(42, 51, 70, 0.04) 0px 10px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 10px 30px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 30px 30px -12px",
			transition: "0.4s",
			duration: "0.4s",
		},
	},
	keyPoints: {
		"& li": {
			color: "#072A40",
			fontSize: "16px",
			textAlign: "left",
			fontWeight: "400",
			marginTop: "10px",
			marginBottom: "10px",
			fontFamily: "Rubik-regular",
		},
		"& li span": {
			color: "#237DB5FF",
			fontSize: "12px",
			textAlign: "left",
			fontWeight: "400",
			marginRight: "5px",
			fontFamily: "Rubik-regular",
		},
	},
	aboutUsKeyPoints: {
		display: "flex",
		flexWrap: "wrap",
		padding: "0px",
		margin: "0px",
		listStyle: "none",
		"& li": {
			cursor: "pointer",
			duration: "0.4s",
			transition: "0.4s",
			color: "#072A40",
			borderRadius: "50px",
			border: "0.5px solid #072A40",
			fontSize: "12px",
			textAlign: "left",
			fontWeight: "400",
			margin: "5px",
			padding: "5px",
			paddingLeft: "20px",
			paddingRight: "20px",
			fontFamily: "Rubik-regular",
			boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
			"&:hover": {
				backgroundColor: "#072A40",
				color: "#fff",
				duration: "0.6s",
				transition: "0.6s",
				boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.2)",
			},
		},
	},
	mainKeyPoint: {
		display: "flex",
		justifyContent: "center",
	},
	keyMainSection: {
		backgroundColor: "#F9F7F0",
		borderRadius: "0.625rem",
		boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
		padding: "20px",
		margin: "15px",
		transition: "0.4s",
		duration: "0.4s",
		"&:hover": {
			boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.2)",
			transition: "0.4s",
			duration: "0.4s",
		},
		borderBottom: "5px solid #1E88CAFF",
	},
	keyPointsSecurity: {
		"& li": {
			color: "#072A40",
			// padding: "10px",
			// borderRadius: "10px",
			// fontSize: "16px",
			// textAlign: "left",
			// fontWeight: "400",
			marginTop: "10px",
			marginBottom: "10px",
			// fontFamily: "Rubik-regular",
		},
	},
	keyPointSubSection: {
		color: "#072A40",
		fontSize: "16px",
		textAlign: "left",
		fontWeight: "400",
		marginTop: "10px",
		marginBottom: "10px",
		fontFamily: "Rubik-regular",

		"& li": {
			color: "#072A40",
			fontSize: "16px",
			textAlign: "left",
			fontWeight: "400",
			marginTop: "10px",
			marginBottom: "10px",
			fontFamily: "Rubik-regular",
		},
		"& li span": {
			color: "#237DB5FF",
			fontSize: "12px",
			textAlign: "left",
			fontWeight: "400",
			marginRight: "5px",
			fontFamily: "Rubik-regular",
		},
	},
	imgRoundedCircle: {
		marginLeft: "5px",
		marginRight: "5px",
		marginBottom: "10px",
		marginTop: "10px",
		padding: "5px",
		borderRadius: "5% !important",
		fontFamily: "Rubik-Medium",
		fontSize: "12px",
		cursor: "pointer",
		boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
		transition: "0.3s",
		"&:hover": {
			boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2)",
		},
		backgroundColor: "#F7FBFF",
	},
	imgRounded: {
		margin: "0 auto",
		width: "30px",
		height: "30px",
		borderRadius: "50% !important",
	},
	paddingBottom: {
		paddingBottom: "35px",
	},
	selectedTiles: {
		backgroundColor: "#eefcff",
	},
	title: {
		color: "#072A40",
		fontSize: "14px",
		textAlign: "center",
		fontWeight: "500",
		marginTop: "5px",
	},
};

export default sectionsPageStyle;
